var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"nav flex"},_vm._l((_vm.nav_list),function(item,index){return _c('li',{key:index,class:_vm.nav_id == item.id ? 'active' : '',on:{"click":function($event){return _vm.nav_tab(item.id)}}},[_vm._v(_vm._s(item.title)+" "),(item.num)?_c('el-badge',{staticClass:"item",attrs:{"value":item.num,"max":99}}):_vm._e()],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }